
/**
 * Library
 * Import library here
 */
import $ from "jquery";
import filters from "@/filters";
import directives from "@/directives";
import { Vue, Component } from "vue-property-decorator";
import { State, Action, Mutation } from "vuex-class";

import { NewsModel } from "@/models/information.model";
import { CoachmarkModel } from "@/models/coachmark.model";

import News from "./News.vue";
import ModalConfirmDelete from './ModalConfirmDelete.vue';
import CoachMark from '@/components/coachmark/Coachmark.vue';

/**
 * Components
 * Define component here
 */
@Component({
  components: {
    ModalConfirmDelete,
    CoachMark
  },
  directives,
  filters,
})
export default class NewsList extends Vue {
  // ACTION
  @Action("actionSelectNews", { namespace: "information" })
  private actionSelectNews: any;
  @Action("actionResetNews", { namespace: "information" })
  private actionResetNews: any;
  @Action("actionPaginationNew", { namespace: "information" })
  private actionPaginationNew: any;
  @Action("actionPaginationNews", { namespace: "information" })
  private actionPaginationNews: any;
  @Action("actionSelectCoachmark", { namespace: "coachmark" })
  private actionSelectCoachmark: any;
  @Action("actionUpdateCoachmark", { namespace: "coachmark" })
  private actionUpdateCoachmark: any;

  // STATE
  @State("news", { namespace: "information" })
  private news: any;
  @State("array_news", { namespace: "information" })
  private array_news: any;
  @State("pagination_news", { namespace: "information" })
  private pagination_news: any;
  @State("school", { namespace: "academy" })
  private school: any;
  @State("coachmark_data", { namespace: "coachmark" })
  private coachmark_data: CoachmarkModel;

  @Mutation("mutationNews", {namespace: 'information'})
  private mutationNews: any;

  private showSearchJob: boolean = false;
  private isShowDeleteModal: boolean = false;
  private onLoad: boolean = false;
  private activePage: number = 1;
  private activeIndex: number = 0;

  // COMPUTED
  private get showCoachMarkNews() {
    // Old
    // const coachmark_news = localStorage.getItem('coachmark_news');

    // New
    const coachmark_news = this.coachmark_data.coachmark_news;
    return !coachmark_news;
  }

  private deleteLocIcon = require('@/assets/Icon/Garnet/icon_DeleteClose.svg')
  private deleteIcon = `<img src="${this.deleteLocIcon}" width="20" height="20" alt="" srcset="" />`
  private updateLocIcon = require('@/assets/Icon/Shapphire/icon_Edit.svg')
  private updateIcon = `<img src="${this.updateLocIcon}" width="20" height="20" alt="" srcset="" />`

  private get steps() {
    return [
      {
        target: "ButtonSearch",
        title: this.$t('coachmark_title_news1'),
        content: this.$t('coachmark_desc_news1'),
      },
      {
        target: "news-item-0",
        placement: "top",
        title: this.$t('coachmark_title_news2'),
        content: this.$t('coachmark_desc_news2', {delete: this.deleteIcon, edit: this.updateIcon}),
      },
      {
        target: "ButtonAddNews",
        placement: "left",
        title: this.$t('coachmark_title_news3'),
        content: this.$t('coachmark_desc_news3'),
      },
    ]
  }

  /* LIFECYCLE */

  private created() {
    this.actionResetNews();
    this.clickSearch();
    const self = this;
    this.activePage = 0;
    $(window).scroll(function() {
      const height = ($(document).height() as number) - ($(window).height() as number);
      if (($(window).scrollTop() as number) >= height) {
        if (!self.onLoad) {
          if (self.array_news.length == 0) {
            return;
          }
          if (self.onLoad) {
            return;
          }
          if (self.pagination_news.url) {
            self.activePage++;
            self.clickPage(self.activePage, self.pagination_news.url);
          }
        }
      }
    });
  }

  private mounted() {
    this.actionSelectCoachmark({
      success: () => {
        if (!this.showCoachMarkNews) $(".overlayCoachMark").remove();
      }
    });
  }

  private beforeRouteLeave(to: any, from: any, next: any) {
    $(window).unbind("scroll");
    next();
  }

  /* LISTENER */

  private listenerDelete() {
    this.mutationNews(new NewsModel());
    this.isShowDeleteModal = false;
    this.clickSearch();
  }

  /* METHODS */

  private onPrevCoachMark() {
    this.activeIndex--;
    $('.overlayCoachMark').remove()
  }

  private onNextCoachMark() {
    this.activeIndex++;
    $('.overlayCoachMark').remove()
    if (this.activeIndex == 3) {
      // Old
      // localStorage.setItem("coachmark_news", "done");

      // New
      this.coachmark_data.coachmark_news = true;
      this.actionUpdateCoachmark({
        success: () => {
          this.actionSelectCoachmark();
        },
      });
    }
  }

  /**
   * https://developerx.atlassian.net/browse/CS-5342
   *
   * Created at : 14 January 2022           Updated at : 14 January 2022
   * Created by : Risman Abdilah            Updated by : Risman Abdilah
   *
   * Version 1.0.0
   */
  private onHideCoachMark(lastStep?: number) {
    if (lastStep) {
      this.activeIndex = lastStep + 1;
    }
    $(".overlayCoachMark").remove();
    // Old
    // localStorage.setItem("coachmark_news", "done");

    // New
    this.coachmark_data.coachmark_news = true;
    this.actionUpdateCoachmark({
      success: () => {
        this.actionSelectCoachmark();
      },
    });
  }

  private clickSearch() {
    this.actionSelectNews({ school: this.school, news: this.news });
  }

  private clickDelete(data: any) {
    this.isShowDeleteModal = true;
    this.mutationNews(data);
  }

  private onSearch() {
    this.mutationNews(this.news);
    this.clickSearch();
    (this.$refs.searchNews as any).hide();
  }

  private onReset() {
    this.mutationNews(new NewsModel());
    this.clickSearch();
    (this.$refs.searchNews as any).hide();
  }

  private clickPage(page: number, url: string) {
    if (url) {
      this.actionPaginationNews({
        url,
        page,
        success: () => {
          this.onLoad = false;
        }
      });
    } else {
      this.clickSearch();
    }
  }

  private navigateNewsAdd(hideCoachmark = false) {
    if (hideCoachmark) {
      this.onHideCoachMark(3);
    }
    this.actionResetNews();
    this.$router.push({ name: 'newsAdd' })
  }

  // private clickShowSearchJob(isShow: any) {
  //   const $element = $('input[type="text"]#search');
  //   if (isShow) {
  //     if ($(window).width() <= 735) {
  //       $("#titleSection span").hide();
  //       $("#titleSection .ContainerSearch").css("margin-left", 0);
  //     }
  //     this.showSearchJob = isShow;
  //     $element.css("max-width", 0);
  //     setTimeout(() => {
  //       $element.css("max-width", $element.parent().width() * 10);
  //     }, 10);
  //   } else {
  //     if ($(window).width() <= 735) {
  //       $("#titleSection span").show();
  //       $("#titleSection .ContainerSearch").css("margin-left", 10);
  //     }
  //     // this.searchJob = "";
  //     $element.css("max-width", 0);
  //     setTimeout(() => {
  //       this.showSearchJob = isShow;
  //     }, 300);
  //   }
  // }
}
